import React from 'react';
import { Typography } from 'antd';
import cn from 'classnames';
import moment from 'moment';
import getName from '../../../../helpers/getName';
import styles from './MetaDataBlock.module.scss';

const { Text } = Typography;

const MetaDataBlock = ({ attachment, columnAmount }) => {
  const { createDate, user, createWorker } = attachment || {};

  const author = user || createWorker;

  return (
    <div className={styles[`metaDataBlock-col-${columnAmount}`]}>
      {author && (
        <div className={styles[`authorBlock-col-${columnAmount}`]}>
          {author.specialityName && (
            <Text className={cn(styles.text, styles.accent)}>
              {author.specialityName}
            </Text>
          )}
          <Text className={styles.text}>{getName(author) || ''}</Text>
        </div>
      )}
      {createDate && <Text>{moment(createDate).format('DD.MM.YYYY')}</Text>}
    </div>
  );
};

export default MetaDataBlock;
